








































































































































































































































import { Component, Watch } from "vue-property-decorator";
import Vue from "vue";
import Notification from "@/components/Notification.vue";
import { userModule } from "@/store/modules/user";
import { appModule } from "./store/modules/app";
import http from "@/http/axios";

@Component({
  components: {
    Notification,
  },
})
export default class App extends Vue {
  get standalonePage() {
    return Boolean(this.$route.meta && this.$route.meta.standalone);
  }

  get signedIn() {
    return userModule.isSignedIn;
  }

  get user() {
    return userModule.user;
  }
  public role = false;
  private mini = false;
  private isRootComponent = true;
  public drawer = window.innerWidth > 960;
  private fixed = false;
  public ownerItems: AppMenu[] = [
    {
      icon: "tachometer-alt",
      menu_type:"healthcare",
      title: "血壓脈搏圖表",
      vertical: "Dashboard",
      link: "dashboard",
    },
    {
      icon: "tachometer-alt",
      menu_type:"healthcare",
      title: "血氧體溫圖表",
      vertical: "Monitor",
      link: "monitor",
    },
    {
      icon: "users",
      menu_type:"healthcare",
      title: "個案名單",
      vertical: "Patient",
      link: "patients",
    },
    {
      icon: "user-nurse",
      menu_type:"management",
      title: "照護人員名單",
      vertical: "Paramedic",
      link: "paramedic",
    },
    {
      icon: "check",
      menu_type:"management",
      title: "個案審核",
      vertical: "verifyPatients",
      link: "verifyPatients",
    },
    {
      icon: "key",
      menu_type:"system",
      title: "API列表",
      vertical: "apiList",
      link: "apilist",
    },
    {
      icon: "user-tag",
      menu_type:"system",
      title: "權限列表",
      vertical: "roleList",
      link: "rolelist",
    },
    {
      icon: "bell",
      menu_type:"healthcare",
      title: "通知列表",
      vertical: "notification",
      link: "notification",
    },
    {
      icon: "map-marked",
      menu_type:"system",
      title: "地區設置",
      vertical: "placesetup",
      link: "placesetup",
    },
    {
      icon: "clipboard-list",
      menu_type:"system",
      title: "社區統計設定",
      vertical: "communitysettings",
      link: "communitysettings",
    },
    {
      icon: "server",
      menu_type:"system",
      title: "排程設置",
      vertical: "schedulersetup",
      link: "schedulersetup",
    },
    {
      icon: "clock",
      menu_type:"management",
      title: "asus手錶資料",
      vertical: "asusdevice",
      link: "asusdevice",
    },
    {
      icon: "laptop-medical",
      menu_type:"system",
      title: "機器統計",
      vertical: "devices",
      link: "devices",
    },
    {
      icon: "history",
      menu_type:"healthcare",
      title: "社區歷史幻燈片",
      vertical: "map",
      link: "map",
    },
    {
      icon: "map",
      menu_type:"healthcare",
      title: "社區地圖統計",
      vertical: "new_map",
      link: "new_map",
    },
    {
      icon: "history",
      menu_type:"healthcare",
      title: "地圖歷史資料",
      vertical: "maphistory",
      link: "maphistory",
    },
  ];
  public adminItems: AppMenu[] = [
    {
      icon: "tachometer-alt",
      menu_type:"healthcare",
      title: "血壓脈搏圖表",
      vertical: "Dashboard",
      link: "dashboard",
    },
    {
      icon: "tachometer-alt",
      menu_type:"healthcare",
      title: "血氧體溫圖表",
      vertical: "Monitor",
      link: "monitor",
    },
    {
      icon: "users",
      menu_type:"healthcare",
      title: "個案名單",
      vertical: "Patient",
      link: "patients",
    },
    {
      icon: "user-nurse",
      menu_type:"management",
      title: "照護人員名單",
      vertical: "Paramedic",
      link: "paramedic",
    },
    {
      icon: "check",
      menu_type:"management",
      title: "個案審核",
      vertical: "verifyPatients",
      link: "verifyPatients",
    },
    {
      icon: "key",
      menu_type:"system",
      title: "API列表",
      vertical: "apiList",
      link: "apilist",
    },
    {
      icon: "user-tag",
      menu_type:"system",
      title: "權限列表",
      vertical: "roleList",
      link: "rolelist",
    },
    {
      icon: "bell",
      menu_type:"healthcare",
      title: "通知列表",
      vertical: "notification",
      link: "notification",
    },
    {
      icon: "map-marked",
      menu_type:"system",
      title: "地區設置",
      vertical: "placesetup",
      link: "placesetup",
    },
    {
      icon: "clipboard-list",
      menu_type:"system",
      title: "社區統計設定",
      vertical: "communitysettings",
      link: "communitysettings",
    },
    {
      icon: "clock",
      menu_type:"management",
      title: "asus手錶資料",
      vertical: "asusdevice",
      link: "asusdevice",
    },
    {
      icon: "laptop-medical",
      menu_type:"system",
      title: "機器統計",
      vertical: "devices",
      link: "devices",
    },
    {
      icon: "history",
      menu_type:"healthcare",
      title: "社區歷史幻燈片",
      vertical: "map",
      link: "map",
    },
    {
      icon: "map",
      menu_type:"healthcare",
      title: "社區地圖統計",
      vertical: "new_map",
      link: "new_map",
    },
    {
      icon: "history",
      menu_type:"healthcare",
      title: "地圖歷史資料",
      vertical: "maphistory",
      link: "maphistory",
    },
    // {
    //   icon: "clock",
    //   menu_type:"healthcare",
    //   title: "asus手錶資料",
    //   vertical: "asusdevice",
    //   link: "asusdevice",
    // },
  ];

  public developItems: AppMenu[] = [
    {
      icon: "key",
      menu_type:"system",
      title: "API列表",
      vertical: "apiList",
      link: "apilist",
    },
  ];

  public paramedicItems: AppMenu[] = [
    {
      icon: "tachometer-alt",
      menu_type:"healthcare",
      title: "血壓脈搏圖表",
      vertical: "Dashboard",
      link: "dashboard",
    },
    {
      icon: "tachometer-alt",
      menu_type:"healthcare",
      title: "血氧體溫圖表",
      vertical: "Monitor",
      link: "monitor",
    },
    {
      icon: "users",
      menu_type:"healthcare",
      title: "個案名單",
      vertical: "Patient",
      link: "patients",
    },
  ];

  public items: AppMenu[] = [
    // {
    //   icon: "home",
    //   title: "社區狀態顯示表",
    //   vertical: "community",
    //   link: "communities"
    // },
  ];

  private userMenus: AppMenu[] = [
    {
      icon: "bubble_chart",
      menu_type:"user",
      title: "修改個人資料",
      link: "userInfo",
    },
    {
      icon: "bubble_chart",
      menu_type:"user",
      title: "登出",
      link: "Login",
    },
  ];

  private healthcareitems: AppMenu[] = [];
  private managementitems: AppMenu[] = [];
  private systemitems: AppMenu[] = [];

  private miniVariant = false;
  private right = true;
  private rightDrawer = false;
  private menuItem = "";

  private editDialog = false;
  private dateMenu = false;
  private date = new Date().toISOString().substr(0, 10);
  private editItem = {
    age: 0,
    birthday: "",
    created_at: "",
    gender: "",
    health_state: 0,
    iid: 0,
    id_card: "",
    name: "",
    phone: "",
    updated_at: "",
    uuid: "",
    email: "",
    place: "",
  };

  @Watch("$route", { immediate: true, deep: true })
  onUrlChange(to, from) {
    if (this.signedIn && from.name == "Login") {
      this.role = true;
      location.reload();
    }
  }

  @Watch("this.role", { immediate: true, deep: true })
  onsignedIn() {
    this.roleItem();
  }

  created() {
    //  [App.vue specific] When App.vue is first loaded start the progress bar
    // this.$Progress.start();
    //  hook the progress bar to start before we move router-view
    this.$router.beforeEach((to, _from, next) => {
      //  does the page we want to go to have a meta.progress object
      if (to.meta.progress !== undefined) {
        const meta = to.meta.progress;
        // parse meta tags
        this.$Progress.parseMeta(meta);
      }
      //  start the progress bar
      this.$Progress.start();
      //  continue to next page
      next();
    });
    //  hook the progress bar to finish after we've finished moving router-view
    this.$router.afterEach((to) => {
      if (to.name !== "ErrorPage") {
        this.menuItem = to.name;
      }
      //  finish the progress bar
      this.$Progress.finish();
    });
  }
  get MenuClass(){
    return [
      {
        name:'健康紀錄',
        items: this.healthcareitems
      },
      {
        name:'人員管理',
        items: this.managementitems
      },
      {
        name:'系統設定',
        items: this.systemitems
      },
    ];
  }

  roleItem() {
    if (!this.signedIn) return;
    else {
      if (
        this.user.roles.includes("Owner")
      ) {
        this.items = this.items.concat(this.ownerItems);
      } else if (this.user.roles.includes("Admin")) {
        this.items = this.items.concat(this.adminItems);
      }else if (this.user.roles.includes("Developer")) {
        this.items = this.items.concat(this.developItems);
      } else if (this.user.roles.includes("Paramedic")) {
        this.items = this.items.concat(this.paramedicItems);
      }
      this.items.forEach(item=>{
        switch(item.menu_type){
          case "healthcare":
            this.healthcareitems.push(item);
            break;
          case "management":
            this.managementitems.push(item);
            break;
          case "system":
            this.systemitems.push(item);
            break;
          default:
            break;
        }
      });
      return;
    }
  }

  get activeMenuItem() {
    return this.menuItem;
  }

  get loading() {
    return appModule.loading;
  }

  get snackbar() {
    return appModule.snackbar;
  }

  get notice() {
    return appModule.notice;
  }

  get mode() {
    return appModule.mode;
  }

  closeSnackbar() {
    appModule.closeNotice();
  }

  handleNavigtiion(item: TODO) {
    this.menuItem = item.title;
    this.$router.push({
      name: item.title,
    });
  }

  async handleUserActions(item: TODO) {
    this.menuItem = item.title;
    if (item.title === "登出") {
      await userModule.logout();
      this.$router.push({ path: "/login" });
    } else if (item.title === "修改個人資料") {
      this.editDialog = true;
      this.editItem = JSON.parse(JSON.stringify(this.user));
      this.editItem.phone = this.editItem.phone.substring(
        4,
        this.editItem.phone.length
      );
    }
  }

  async saveEdit() {
    if (this.editItem.gender === "男") this.editItem.gender = "1";
    else if (this.editItem.gender === "女") this.editItem.gender = "2";
    if (this.editItem.phone != "") {
      this.editItem.phone = "+886" + this.editItem.phone;
    }

    const params = {
      age: this.editItem.age,
      gender: this.editItem.gender,
      name: this.editItem.name,
      phone: this.editItem.phone,
      place: this.editItem.place,
    };

    const result = await http.put("/user/" + this.editItem.uuid, params);
    if (result) {
      if (result.data.status === "Success") {
        appModule.sendSuccessNotice("修改成功，請重新登入以便檢查資料是否正確");
      } else {
        appModule.sendErrorNotice("修改失敗");
      }
    } else {
      console.error(result.data.status);
    }
    this.closeEdit();
  }

  closeEdit() {
    this.editItem = {
      age: 0,
      birthday: "",
      created_at: "",
      gender: "",
      health_state: 0,
      iid: 0,
      id_card: "",
      name: "",
      phone: "",
      updated_at: "",
      uuid: "",
      email: "",
      place: "",
    };
    this.editDialog = false;
  }
}
